import { withI18n } from 'wix-rich-content-common';
import englishResources from 'wix-rich-content-common/dist/statics/locale/messages_en.json';
import RichContentViewer from './RichContentViewer';

export default withI18n(RichContentViewer, englishResources);
